/** Necha kun oldinga qarash: 7 yoki 14 */
import { useTranslation } from "react-i18next";
import type { Me } from "@/features/auth/types";
import { Select } from "@/components/ui/field";
import type { WidgetItem } from "../types";
import type { StartsConfig } from "./index";

type Props = { item: WidgetItem<StartsConfig>; me: Me; onChange: (config: StartsConfig) => void };

export function StartsSettings({ item, onChange }: Props) {
  const { t } = useTranslation("widgets");
  return (
    <label className="block text-[12px] text-muted">
      {t("starts.daysLabel")}
      <Select value={String(item.config.days)} onChange={(e) => onChange({ days: Number(e.target.value) === 14 ? 14 : 7 })} className="mt-1">
        <option value="7">{t("starts.days", { count: 7 })}</option>
        <option value="14">{t("starts.days", { count: 14 })}</option>
      </Select>
    </label>
  );
}
